import pages from './pages.js'

const routes = [
    {
        path: '/',
        redirect: '/layout'
    },
    {
        path: '/login',
        name: '登录',
        component: () => import('../components/layout/page.vue')
    },
    {
        path: '/update-info/:type',
        name: '设计师入驻',
        component: () => import('@/views/checkIn/list')
    },
    {
        name: 'layout',
        path: '/layout',
        redirect: '/demo/show',
        component: () => import('../components/layout/page.vue'),
        children: [...pages]
    }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/routes.js